import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css"; // Required for styling
import $ from "jquery"; // Required for jQuery to work with DataTable
import "datatables.net"; // Import DataTable jQuery plugin

function UserList() {
  const navigate = useNavigate();
  const [dataTable, setDataTable] = useState(null); // For storing DataTable instance

  // Function to fetch data with pagination
  const fetchData = async (page, search = "", length= "") => {
    try {
      const limit = length || 10; // Limit per page
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY, // Sensitive data: Use env variables for production
          secret: process.env.REACT_APP_SECRET, // Sensitive data: Use env variables for production
          method: "userList",
          module: "user",
          index: page,
          limit: limit,
          search: search, // Send search term if available
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        const users = data.result.users;
        const totalUsers = data.result.pagination.totalUsers; // Get total users count

        return {
          draw: data.draw, // Draw counter for DataTable
          recordsTotal: totalUsers, // Total records (from API)
          recordsFiltered: totalUsers, // Filtered records (can be same if no filters)
          data: users, // Data for the current page
        };
      } else {
        console.error("Failed to fetch users:", data);
        return {
          draw: 0,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [],
        };
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return {
        draw: 0,
        recordsTotal: 0,
        recordsFiltered: 0,
        data: [],
      };
    }
  };

  useEffect(() => {
    // Initialize DataTable once
    if (!dataTable) {
      const table = $("#users").DataTable({
        serverSide: true, // Enable server-side processing
        processing: true, // Show processing indicator while loading data
        ajax: function (data, callback, settings) {
          const page = settings._iDisplayStart / settings._iDisplayLength + 1; // Get the page number
          const search = data.search.value || ""; // Get the search query
          const length = data.length || ""; // Get the search query
          console.log("data",data);
          fetchData(page, search,length).then((response) => {
            // Pass data and pagination info to the DataTable callback
            callback({
              draw: response.draw,
              recordsTotal: response.recordsTotal,
              recordsFiltered: response.recordsFiltered,
              data: response.data,
            });
          });
        },
        columns: [
          { data: null, render: (data, type, row, meta) => meta.row + 1 },
          { 
              data: 'mobile', 
              render: (data, type, row) => {
                // Check if both countryCode and mobile exist in row data
                const countryCode = row?.countryCode ? `${row.countryCode}` : 'N/A';
                const mobile = data || 'N/A'; // Fallback to 'N/A' if mobile is not available
                return `${countryCode} ${mobile}`;
              }
            },
          { data: 'deviceType', render: (data) => data ? data.charAt(0).toUpperCase() + data.slice(1) : 'N/A' },
          { data: 'createdAt', render: (data) => new Date(data).toLocaleString() || 'N/A' },
          {
            data: "latitude", // Refers to the "latitude" field in the row data
            render: (data, type, row) => {
              // Check if the latitude and longitude fields are available in the row
              if (row.latitude && row.longitude) {
                const latitude = row.latitude;
                const longitude = row.longitude;
                return `<a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">${Number(latitude).toFixed(4)}, ${Number(longitude).toFixed(4)}</a>`;
              } else {
                return "N/A";
              }
            }
          },
            
          { data: 'lastloginAt', render: (data) => new Date(data).toLocaleString() || 'N/A' },
          {
            data: "location",
            render: (data, type, row) => {
              // Check if geoTagPlace is valid and create a link
              if (data && Array.isArray(data.coordinates)) {
                const latitude = data.coordinates[1];
                const longitude = data.coordinates[0];
                return `<a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">${Number(latitude).toFixed(4)}, ${Number(longitude).toFixed(4)}</a>`;
              } else {
                return "N/A";
              }
            },
          },
          { data: 'lastActivityAt', render: (data) => new Date(data).toLocaleString() || 'N/A' },
          {
            data: "lastLocationHistory",
            render: (data, type, row) => {
                if (data && data.latitude && data.longitude) {
                    const latitude = data.latitude;
                    const longitude = data.longitude;
                    return `<a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">${Number(data.latitude).toFixed(4)}, ${Number(data.longitude).toFixed(4)}</a>`;
                } else {
                    return "N/A";
                }
            }
        },
          {
            data: null,
            render: (data) => {
              // Safely access userId using optional chaining
              const userId = data?._id;
          
              // Check if userId is available
              if (userId  && (data.createdGeotagsCount || 0) > 0) {
                // Return a div containing the clickable link for businessCount
                return `
                  <div align="center">
                    <a href="/usergeotags?id=${userId}&type=created" class="count-link" target="_blank">
                      ${data.createdGeotagsCount || 0}
                    </a>
                  </div>
                `;
              } else {
                return `
                <div align="center">
                  ${data.createdGeotagsCount || 0}
                </div>
              `;
              }
            }
          },{
            data: null,
            render: (data) => {
              // Safely access userId using optional chaining
              const userId = data?._id;
          
              // Check if userId is available
              if (userId && (data.openedGeotagsCount || 0) > 0) {
                // Return a div containing the clickable link for businessCount
                return `
                  <div align="center">
                    <a href="/usergeotags?id=${userId}&type=opened" class="count-link" target="_blank">
                       ${data.openedGeotagsCount || 0}
                    </a>
                  </div>
                `;
              } else {
                return `
                <div align="center">
                  ${data.openedGeotagsCount || 0}
                </div>
              `;
              }
            }
          },{
            data: null,
            render: (data) => {
              // Safely access userId using optional chaining
              const userId = data?._id;
          
              // Check if userId is available
              if (userId) {
                // Return a div containing the clickable link for businessCount
                return `
                  <div align="center">
                    <a href="/usergeotags?id=${userId}&type=saved" class="count-link" target="_blank">
                      ${data.savedGeotagsCount || 0}
                    </a>
                  </div>
                `;
              } else {
                return `
                <div align="center">
                  ${data.savedGeotagsCount || 0}
                </div>
              `;
              }
            }
          },{
            data: null,
            render: (data) => {
              // Safely access userId using optional chaining
              const userId = data?._id;
          
              // Check if userId is available
              if (userId  && (data.businessCount || 0) > 0) {
                // Return a div containing the clickable link for businessCount
                return `
                  <div align="center">
                    <a href="/businesses?id=${userId}" class="count-link" target="_blank">${data.businessCount || 0}
                    </a>
                  </div>
                `;
              } else {
                return `
                <div align="center">
                  ${data.businessCount || 0}
                </div>
              `;
              }
            }
          },
          
          {
            data: null,
            render: (data) => {
              // Safely access userId using optional chaining
              const userId = data?._id;
          
              // Check if userId is available
              if (userId  && (data.contactsCount || 0) > 0) {
                // Return a div containing the clickable link for businessCount
                return `
                  <div align="center">
                    <a href="/contacts?id=${userId}&type=contact" class="count-link" target="_blank">${data.contactsCount || 0}
                    </a>
                  </div>
                `;
              } else {
                return `
                <div align="center">
                  ${data.contactsCount || 0}
                </div>
              `;
              }
            }
          },{
            data: null,
            render: (data) => {
              // Safely access userId using optional chaining
              const userId = data?._id;
          
              // Check if userId is available
              if (userId) {
                // Return a div containing the clickable link for businessCount
                return `
                  <div align="center">
                    <a href="/referrals?id=${userId}&type=refer" class="count-link" target="_blank">
                      ${data.Referrals || 0}
                    </a>
                  </div>
                `;
              } else {
                return `
                <div align="center">
                  ${data.Referrals || 0}
                </div>
              `;
              }
            }
          },
          { data: 'referedByUser', render: (data) => data || 'N/A' },
          
          // other columns
      ],
        pageLength: 10, // Display 10 records per page
        lengthMenu: [10, 25, 50, 75, 100], // Allow the user to change the number of rows per page
        responsive: true,
        searching: true, // Enable search functionality
        paging: true, // Enable pagination
      });

      setDataTable(table); // Store DataTable instance
    }

    // Cleanup DataTable when the component is unmounted
    return () => {
      if (dataTable) {
        dataTable.clear().destroy();
      }
    };
  }, [dataTable]); // Only initialize once

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">Users</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table
                    id="users"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  >
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Phone</th>
                        <th>Device Type</th>
                        <th>CreatedAt</th>
                        <th>Created Location</th>
                        <th>Last Login</th>
                        <th>Last Login Location</th>
                        <th>Last Activity</th>
                        <th>Last Activity Location</th>
                        <th>Dropped</th>
                        <th>Hunted</th>
                        <th>Saved</th>
                        <th>Businesses</th>
                        <th>Contacts</th>
                        <th>Referrals by link</th>
                        <th>Referred by User</th>
                        {/* <th>Referrals by GeoTags</th> */}
                        
                      </tr>
                    </thead>
                    <tbody>
                      {/* Data rows will be populated dynamically via DataTable */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default UserList;
